const Footer = () => (
  <footer className="footer text-end">
    &copy; {(new Date().getFullYear())} - Powered by Barbaricum, LLC
  </footer>
)
  
export default Footer